export default "__VITE_ASSET__xrCPjQD8__"